module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/person.4d9a39b6.svg";